import { render, staticRenderFns } from "./NsTopnavGivingBack.vue?vue&type=template&id=fece9cb4&scoped=true&"
import script from "./NsTopnavGivingBack.vue?vue&type=script&lang=js&"
export * from "./NsTopnavGivingBack.vue?vue&type=script&lang=js&"
import style0 from "./NsTopnavGivingBack.vue?vue&type=style&index=0&id=fece9cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fece9cb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fece9cb4')) {
      api.createRecord('fece9cb4', component.options)
    } else {
      api.reload('fece9cb4', component.options)
    }
    module.hot.accept("./NsTopnavGivingBack.vue?vue&type=template&id=fece9cb4&scoped=true&", function () {
      api.rerender('fece9cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsTopnavGivingBack.vue"
export default component.exports